import React from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import ServiceHighlights from "../components/ServiceHighlights";
import ServicesOverview from "../components/ServicesOverview";
import FAQ from "../components/FAQ";
import Footer from "../components/Footer";
import PartnerMarquee from "../components/PartnerMarquee";
import HelpButton from "../components/HelpButton";
import { Phone } from "lucide-react";
import { Reviews } from "../components/Reviews";
import SEO from "../components/SEO";
import ElektraAanleggenHero from "../components/heroes/ElektraAanleggenHero";

function Elektraaanleg() {
  return (
    <div className="min-h-screen bg-white page-transition pt-[99px] md:pt-[133px]">
      <SEO
        title="Elektra aanleggen in Arnhem - elektricieninarnhem026.nl"
        description="Van nieuwbouw tot uitbreiding: onze experts zorgen voor een veilige en toekomstbestendige elektrische installatie."
        image="/images/banner.png"
      />

      <Header />
      <ElektraAanleggenHero />

      {/* Features Section */}
      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Vakkundige elektra aanleg
            </h2>
            <p>
              Of het nu gaat om een complete nieuwbouwinstallatie of het
              uitbreiden van uw bestaande elektra, onze gecertificeerde
              elektriciens zorgen voor een perfecte installatie. We werken
              volgens de laatste NEN 1010 normen en gebruiken alleen A-kwaliteit
              materialen voor een veilig en duurzaam resultaat. Voor alle
              elektra werkzaamheden kunt u rekenen op onze expertise en
              vakmanschap.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="Professionele elektra aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/groepenkast.png.jpeg"
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Professionele installatie van stopcontacten
            </h2>
            <p>
              Het plaatsen van extra stopcontacten vereist vakkundig werk. Onze
              ervaren elektriciens zorgen voor een veilige installatie volgens
              de laatste NEN-normen. Of het nu gaat om de woonkamer, keuken,
              slaapkamer of studeerkamer, we kunnen stopcontacten in elke ruimte
              van uw woning toevoegen. We garanderen een nette afwerking en
              minimale overlast tijdens de werkzaamheden, zodat u snel kunt
              genieten van de extra aansluitpunten.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Slimme elektrische installaties"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/stopcontact-aansluiten.jpg"
              />
            </div>
          </div>
        </div>
      </section>

      <ServicesOverview />

      <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] mb-12 md:mb-16">
        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-none">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Krachtstroom aanleggen in Arnhem
            </h2>
            <p>
              Heeft u zware elektrische apparatuur zoals een laadpaal, sauna of
              industriële machines in Arnhem? Dan is krachtstroom essentieel.
              Onze gecertificeerde elektriciens in Arnhem zorgen voor een
              veilige en correcte installatie van uw krachtstroomaansluiting. We
              werken volgens de laatste NEN 1010 normen en gebruiken
              hoogwaardige materialen om een betrouwbare en duurzame installatie
              te garanderen.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:-order-1">
            <div className="relative">
              <img
                alt="krachtstroom aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/401034144.webp" // Replace with your krachtstroom image
              />
            </div>
          </div>
        </div>

        <div className="grid items-center w-full gap-12 grid-cols-1 md:grid-cols-2 mb-16 md:mb-20 xl:mb-20">
          <div className="[&_p]:!text-[#17354A] [&_p]:text-base md:[&_p]:text-lg order-2 md:order-1">
            <h2 className="font-bold text-black leading-[1.25] text-[24px] lg:text-[36px] text-[#17354A] mb-4 md:mb-6">
              Meterkast aanleggen in Arnhem
            </h2>
            <p>
              De meterkast is het centrale punt van uw elektrische installatie
              in Arnhem. Of u nu een nieuwe meterkast nodig heeft of uw
              bestaande meterkast wilt uitbreiden, onze elektriciens in Arnhem
              zorgen voor een veilige en professionele installatie. We zorgen
              voor een correcte indeling, voldoende groepen en de juiste
              beveiliging volgens de NEN 1010 normen. Vertrouw op onze expertise
              voor een betrouwbare en toekomstbestendige meterkast.
            </p>

            <div className="h-9"></div>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/offerte"
                aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 focus-visible:border-crustaLight disabled:bg-[#F47B20]/40 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  Offerte aanvragen
                </span>
              </Link>

              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-[48px] text-[#17354A] hover:bg-[#E6B800] hover:text-white focus:opacity-60 w-full md:w-fit"
                style={{ minWidth: "216px" }}
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  Bel direct 085-2129778
                </span>
              </a>
            </div>
          </div>
          <div className="order-1 md:order-2">
            <div className="relative">
              <img
                alt="Professionele meterkast aanleg"
                loading="lazy"
                className="rounded-lg w-full h-auto"
                src="/images/Aanvragen-3-Fase-aansluiting-1-removebg-preview.png" // Replace with your meterkast image
              />
            </div>
          </div>
        </div>
      </section>

      <FAQ />

      <ServiceHighlights />

      <Reviews />

      <PartnerMarquee />

      {/* CTA Section */}
      <div className="w-full cursor-pointer bg-[#FFD100] transition-opacity duration-150 hover:opacity-80">
        <Link
          to="/offerte"
          aria-label="Vraag een vrijblijvende offerte aan voor groepenkast vervanging"
        >
          <section className="mx-auto w-[calc(100%-2.5rem)] max-w-[1088px] text-center py-6 justify-between items-center">
            <div
              data-variant="h2"
              className="font-bold leading-[1.25] text-[28px] lg:text-[36px] self-center text-white mb-0"
            >
              Offerte aanvragen
            </div>
          </section>
        </Link>
      </div>

      <HelpButton />
      <Footer />
    </div>
  );
}

export default Elektraaanleg;
